import {useMainPageAnimationToken} from '@/di/di.root-container.hooks';

import {useEffect, useRef} from 'react';

import s from './MainPageIntroAnimation.module.css';

export function MainPageIntroAnimation(): JSX.Element {
  const containerRef = useRef<HTMLDivElement>(null);
  const mainPageAnimation = useMainPageAnimationToken();

  useEffect(() => {
    if (containerRef.current) {
      void mainPageAnimation.create(containerRef.current);
    }

    return () => mainPageAnimation.destroy();
  }, []);

  return <div ref={containerRef} className={s.root} />;
}
